export function feedFailure(error) {
 const status=Number.isInteger(error?.response?.status)?error.response.status:null;
 const code=typeof error?.code==='string'&&/^[A-Z0-9_]{1,40}$/.test(error.code)?error.code:null;
 const timedOut=code==='ECONNABORTED'||code==='ETIMEDOUT';
 return {
  status,code,endpoint:'/feed',
  kind:timedOut?'timeout':status?'http':'network',
  message:timedOut?'The feed request timed out. Please try again.':status>=500?'The feed is temporarily unavailable. Please try again.':status===403?'The feed request was rejected. Please try again.':'We couldn’t connect to the feed. Please try again.',
 };
}
